export enum AppRoute {
  intro = 'intro',
  backToIntro = 'back-to-intro',
  welcomeOrientation = 'welcome-orientation',
  home = 'home',
  homeTabs = 'home-tabs',
  homeMenu = 'home-menu',
  userProfileWizard = 'profile-wizard',
  notFound = 'not-found',
  universityDetails = 'university-details',
  departmentDetails = 'department-details',
  imprint = 'imprint',
  licenses = 'licenses',
  support = 'support',
  dataPrivacy = 'data-privacy',
  chat = 'chat',
  admin = 'admin',
  deleteAccount = 'delete-account',
}
